import React from 'react';

import './i18n';

import { RouteProvider } from '@providers';
import { initMatomo, initSentry } from '@lib';

import useAppService from './App.service';

initSentry();
initMatomo();
const App: React.FC = () => {
  useAppService();
  return <RouteProvider />;
};

export default App;
